<template>
  <div>
    <message :messages="messages"></message>
    <premium-shared></premium-shared>
    <v-layout row wrap class="pt-3">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="error" :loading="quotation.saving" @click.prevent="doDecline" :disabled="premiumInfo.init !== 1">
        Decline
        <v-icon right dark>mdi-close</v-icon>
      </v-btn>
      <v-btn color="primary" :loading="quotation.saving" @click.prevent="doApprove" :disabled="premiumInfo.init !== 1">
        Approve
        <v-icon right dark>mdi-check</v-icon>
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
import { AGENCY_QUOTATION_LIFECYCLE, AGENCY_QUOTATION_SAVE_LOADING, AGENCY_QUOTATION_SAVE_SUCCESS, AGENCY_QUOTATION_SAVE_FAIL, AGENCY_QUOTATION_LEAVEQUOTE, QUOTE_CARGO_PREMIUM } from '@/store/types'
import MessageMixin from '@/mixins/message'
import { SaveQuoteMixin } from '../../shared/saveQuoteMixin'
import PremiumShared from '../quotation/PremiumShared'
import { generalCargoForm } from '@/store/modules/agency/actions/quote'

export default {
  computed: {
    quotation() {
      return this.$store.state.agency.quotation
    },
    premiumInfo() {
      return this.quotation.commonInfo.premium
    }
  },
  methods: {
    doBack() {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 1)
      this.$router.push({ name: 'cargoQuoteRef' })
    },
    doCalculate() {
      this.$store.dispatch('cargoQuoteCalculate')
    },
    async doApprove() {
      const apiUrl = this.quotation.menu.approveRefQuote
      if (apiUrl) {
        try {
          this.$store.commit(AGENCY_QUOTATION_SAVE_LOADING)
          const result = await this.$http.post(apiUrl, generalCargoForm(this.$store.state.agency))
          this.$store.commit(AGENCY_QUOTATION_SAVE_SUCCESS)
          this.$snotify.success('Quotation has been approved')
          // After success push to listing page
          this.$store.commit(AGENCY_QUOTATION_LEAVEQUOTE)
          this.$router.push({ name: 'cargoQuoteQuery', params: { id: result.data.proposalNo } })
        } catch (err) {
          if (err.response && err.response.data) {
            this.fullMessage(err.response.data)
          }
          // We need this to stop the loading (err msg will be displayed directly)
          this.$store.commit(AGENCY_QUOTATION_SAVE_FAIL, {})
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    async doDecline() {
      const apiUrl = this.quotation.menu.declineRefQuote
      if (apiUrl) {
        try {
          this.$store.commit(AGENCY_QUOTATION_SAVE_LOADING)
          const result = await this.$http.post(apiUrl, generalCargoForm(this.$store.state.agency))
          this.$store.commit(AGENCY_QUOTATION_SAVE_SUCCESS)
          this.$snotify.success('Quotation has been declined')
          // After success push to listing page
          this.$store.commit(AGENCY_QUOTATION_LEAVEQUOTE)
          this.$router.push({ name: 'cargoQuoteQuery', params: { id: result.data.proposalNo } })
        } catch (err) {
          if (err.response && err.response.data) {
            this.fullMessage(err.response.data)
          }
          // We need this to stop the loading (err msg will be displayed directly)
          this.$store.commit(AGENCY_QUOTATION_SAVE_FAIL, {})
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    async doPartialSave() {
      try {
        this.$store.commit(QUOTE_CARGO_PREMIUM, this.cargoForm)
        await this.$store.dispatch('saveQuote')
        return true
      } catch (err) {
        return false
      }
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.agency.quotation.quoteLifeCycle !== 2) {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 2)
    }
  },
  mounted() {
    this.doCalculate()
  },
  mixins: [
    MessageMixin,
    SaveQuoteMixin
  ],
  components: {
    PremiumShared
  }
}
</script>

<style>

</style>
